'use client';

import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ThemeContextType {
  isDark: boolean;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [isDark, setIsDark] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme !== null) {
      setIsDark(savedTheme === 'dark');
    }
  }, []);

  useEffect(() => {
    if (mounted) {
      localStorage.setItem('theme', isDark ? 'dark' : 'light');
      document.body.className = isDark ? 'dark' : 'light';
    }
  }, [isDark, mounted]);

  const toggleTheme = () => setIsDark(!isDark);

  return <ThemeContext.Provider data-component-id="src/contexts/ThemeContext.tsx:33:9" data-component-path="src/contexts/ThemeContext.tsx" data-component-line="33" data-component-end-line="33" data-component-file="ThemeContext.tsx" data-component-name="ThemeContext.Provider" data-component-content="%7B%22elementName%22%3A%22ThemeContext.Provider%22%7D" value={{ isDark, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
